import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IWorkflowEngine from "@/interfaces/workflow-engine.interfaces";
import workflowService from "@/services/workflow.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetWorkflowEngineByIdReturn = RequestsBaseReturn<IWorkflowEngine | null>;

export type UseGetWorkflowEngineByIdProps = ByIdRequestProps;

type UseSwrGetWorkflowEngineByIdParams = [string, number];

const useGetWorkflowEngineById = ({
  _id,
}: UseGetWorkflowEngineByIdProps): UseGetWorkflowEngineByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IWorkflowEngine, Error, UseSwrGetWorkflowEngineByIdParams | null>(
    _id ? [SWR_KEYS.getWorkflowEngineById, _id] : null,
    ([, workflowEngineId]) => workflowService.geWorkflowEngineBackofficeById(workflowEngineId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetWorkflowEngineById;
